import {
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { IonCheckbox, PickerController } from '@ionic/angular';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
})
export class ScheduleComponent implements OnInit {
  @Input() editing;
  @Input() reMaking;
  @ViewChildren(IonCheckbox) checkbox: QueryList<IonCheckbox>;

  days = [
    {
      day: 'WORDS.LU',
      checked: false,
    },
    {
      day: 'WORDS.MA',
      checked: false,
    },
    {
      day: 'WORDS.MI',
      checked: false,
    },
    {
      day: 'WORDS.JU',
      checked: false,
    },
    {
      day: 'WORDS.VI',
      checked: false,
    },
    {
      day: 'WORDS.SA',
      checked: false,
    },
    {
      day: 'WORDS.DO',
      checked: false,
    },
  ];

  scheduleSetted: any[] = [
    {
      days: [],
      end: '',
      init: '',
      availableDays: this.days,
    },
  ];

  constructor(
    private picker: PickerController,
    private toastService: ToastService
  ) {}

  ngOnInit() {}

  setDaysToSchedule(ev, selectedSchedule) {
    let exist = false;
    if (typeof selectedSchedule.days === 'string') {
      return;
    }

    if (ev.detail.checked) {
      if (!selectedSchedule.days) {
        selectedSchedule.days = [];
      }
      selectedSchedule.days.push(JSON.parse(JSON.stringify(ev.detail.value)));
      exist = true;
    } else {
      // if(!selectedSchedule.days) selectedSchedule.days = this.days;
      selectedSchedule.days =
        selectedSchedule.days?.filter((days) => days !== ev.detail.value) || [];
      exist = false;
    }

    selectedSchedule.availableDays.find((day) => {
      if (day.day === ev.detail.value) {
        day.checked = exist;
      }
    });
  }

  async selectSchedule(ScheduleDate, selectedSchedule) {
    const schedule = [];
    for (let i = 0; i < 24; i++) {
      schedule.push({
        text: i < 10 ? `0${i}:00` : `${i}:00`,
        value: i < 10 ? `0${i}:00` : `${i}:00`,
      });
    }

    const picker = await this.picker.create({
      buttons: [
        {
          text: 'Confirmar',
          handler: (selected) => {
            if (ScheduleDate === 'desde') {
              selectedSchedule.init = selected.open.value;
            } else if (ScheduleDate === 'hasta') {
              0;
              selectedSchedule.end = selected.open.value;
            }
          },
        },
      ],
      columns: [
        {
          name: 'open',
          options: schedule,
        },
      ],
    });

    await picker.present();
  }

  async setNewSchedule(selectedSchedule, iconSet?, actualSchedule?) {
    if (!selectedSchedule.init || !selectedSchedule.end) {
      return this.toastService.show(
        'Debes establecer un horario antes de agregar otro'
      );
    }
    const daysDisp = [
      {
        day: 'WORDS.LU',
        checked: false,
      },
      {
        day: 'WORDS.MA',
        checked: false,
      },
      {
        day: 'WORDS.MI',
        checked: false,
      },
      {
        day: 'WORDS.JU',
        checked: false,
      },
      {
        day: 'WORDS.VI',
        checked: false,
      },
      {
        day: 'WORDS.SA',
        checked: false,
      },
      {
        day: 'WORDS.DO',
        checked: false,
      },
    ];

    daysDisp.map((day, index) => {
      const newObj = selectedSchedule.availableDays[index];
      if (newObj.checked !== day.checked) {
        daysDisp[index] = selectedSchedule.availableDays[index];
      }
    }, []);

    const isAvailable = daysDisp.find((day) => day.checked === false);

    if (!this.reMaking) {
      console.log('actualSchedule :>> ', actualSchedule);
      const data = JSON.parse(JSON.stringify(actualSchedule));
      this.scheduleSetted.push({
        ...data,
        availableDays: JSON.parse(JSON.stringify(daysDisp)),
      });
      return true;
    }

    if (isAvailable) {
      this.scheduleSetted.push({
        day: [],
        end: '',
        init: '',
        availableDays: JSON.parse(JSON.stringify(daysDisp)),
      });
    }
  }

  deleteTime() {
    this.scheduleSetted = [
      {
        days: [],
        end: '',
        init: '',
        availableDays: this.days,
      },
    ];

    this.reMaking = true;
  }

  fillSchedules(schedule) {
    this.scheduleSetted = [];
    schedule.map((item, index) => {
      if (typeof item?.available_days === 'string') {
        const days = JSON.parse(item.available_days);
        item.availableDays = days;
        this.setNewSchedule(item, null, schedule[index]);
      }
    });
  }

  unselectCheckboxes() {
    return new Promise((resolve, reject) => {
      this.days.forEach((day) => (day.checked = false));
      this.checkbox.forEach((checkboxes) => {
        checkboxes.checked = false;
      });
      resolve(true);
    });
  }

  removeSchedule(index) {
    this.scheduleSetted.splice(index, 1);
  }
}
